@if (ifrLayer?.timeMap?.()?.size! > 1) {
  <jmkw-time-span-select
    [layer]="ifrLayer"
    [timeMultiplier]="timeMultiplier"
    (selectionChanged)="updateSelectedTime($event)"
  ></jmkw-time-span-select>
}
<div class="svg-wrapper">
  <flight-rules-legend-svg></flight-rules-legend-svg>
</div>
